// получаем роли
export const getRolesSD = (state) => state.staticData?.roles;

// получаем тематики
export const getThematicsSD = (state) => state.staticData?.thematics;

// получаем направления
export const getDirectionsSD = (state) => state.staticData?.directions;
